<template>
  <div style="background-color:#f4f5f5; height:100%">
    <van-nav-bar title="服務條款" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div style="max-width:640px; margin-left:7px; margin-top:10px; margin-right:7px;">
      <van-cell style="border-radius:20px;" size="large" value="内容">
<p><span style="font-size: 18pt;"><span style="color: #009e25;">小泉士多</span> 服務條款</span></p>
<p>&nbsp;</p>
<p>本服務條款及條件（以下簡稱「本條款」）規範<span>小泉士多行銷有限公司</span>（以下簡稱「<span>小泉士多</span>」）提供所有<span>小泉士多</span>相關產品與服務（以下簡稱「本服務」）給本服務的用戶（以下簡稱「用戶」）使用時所適用的條款及條件。</p>
<p><span>&nbsp;</span></p>
<p><span>1. </span>定義</p>
<p>本條款使用下列各項用語：</p>
<p><span>1.1. </span>「內容」係指文字、語音、音樂、圖片、影片、軟體、程式、代碼及其他資訊等內容。</p>
<p><span>1.2. </span>「本內容」係指可透過本服務連結的內容。</p>
<p><span>1.3. </span>「投稿內容」係指用戶投稿、傳送、上傳至本服務的內容。</p>
<p><span>1.4. </span>「代幣」係指可兌換本服務中有償提供的服務或內容的預付支付工具等。</p>
<p><span>1.5. </span>「個別使用條款」係指與本服務有關但有別於本條款，以「條款」、「準則」、「政策」等名稱由<span>小泉士多</span>所發布或上傳的條款及條件。</p>
<p><span>&nbsp;</span></p>
<p><span>2. </span>對於本條款的同意表示</p>
<p><span>2.1. </span>用戶應遵照本條款規定使用本服務。除非用戶同意本條款，否則不得使用本服務。</p>
<p><span>2.2. </span>如用戶為未成年人，須經過親權人等法定代理人同意後，方能使用本服務。此外，如用戶代表業者使用本服務時，亦請於該業者同意本條款後，再使用本服務。</p>
<p><span>2.3. </span>本服務於有適用之個別使用條款時，除本條款外，用戶亦應遵照個別使用條款規定使用本服務。</p>
<p><span>&nbsp;</span></p>
<p><span>3. </span>條款的變更</p>
<p><span>小泉士多</span>得於必要時，依據相關法律或法規，於本服務目的範圍內變更本條款。若有相關變更，<span>小泉士多</span>將於本服務或<span>小泉士多</span>網站公告本條款之變更內容及生效日期，或以<span>小泉士多</span>決定的其他方式通知用戶。</p>
<p>本條款之變更將於其生效日當天生效。</p>
<p><span>&nbsp;</span></p>
<p><span>4. </span>帳號</p>
<p><span>4.1. </span>用戶於使用本服務時可能需要註冊特定資料以設立帳戶。用戶應提供真實、正確且完整的資料，並應進行修改以隨時提供更新的資料。</p>
<p><span>4.2. </span>用戶如於使用本服務時註冊任何驗證資訊，應自行負責謹慎保管該等資訊，以免遭到不當使用。當用戶於註冊時提交的驗證資訊被用於使用本服務時，<span>小泉士多</span>將推定該使用係由提交驗證資訊之用戶本人所為，並據此向其提供本服務。</p>
<p><span>4.3. </span>於本服務註冊的用戶，得隨時刪除帳號終止本服務。</p>
<p><span>4.4. 小泉士多</span>得在不事先通知用戶的情形下，刪除自最後一次連線起已經過一年以上的帳號。</p>
<p><span>4.5. </span>自帳號刪除時起，用戶於本服務的所有使用權不論任何理由均為消滅。即便是用戶不慎刪除帳號，原有的帳號亦無法回復，敬請留意。</p>
<p><span>4.6. </span>本服務的帳號專屬於用戶個人。用戶於本服務的所有使用權皆不得轉讓、出借或以其他方式授予第三人或使第三人繼承或繼受。</p>
<p><span>&nbsp;</span></p>
<p><span>5. </span>隱私權</p>
<p><span>5.1. 小泉士多</span>尊重用戶的隱私權。</p>
<p><span>5.2. 小泉士多</span>依照<span><a href="https://www.koizumishop.com/privacy">小泉士多 <span><span>隱私權政策</span></span></a></span>，妥善處理用戶的隱私資料與個人資料。</p>
<p><span>5.3. 小泉士多</span>將會以安全的方式管理自用戶處蒐集的資料，並對安全管理採取嚴格的措施。</p>
<p><span>&nbsp;</span></p>
<p><span>6. </span>服務的提供</p>
<p><span>6.1. </span>用戶就本服務的使用，應自費及負責備置必要的個人電腦、行動裝置、智慧型手機及其他通信設備、作業系統、通信方式及電力等。</p>
<p><span>6.2. 小泉士多</span>得按用戶年齡及身分、有無註冊資料、及其他<span>小泉士多</span>判斷為必要的條件，將本服務的全部或部分提供給符合上揭條件的用戶。</p>
<p><span>6.3.&nbsp; 小泉士多</span>保留權利於認為有必要時，得不事先通知用戶，隨時自行決定變更本服務的全部或部分內容。</p>
<p><span>6.4. </span>於下列情況下，<span>小泉士多</span>得不事先通知用戶，中止提供本服務之全部或一部：</p>
<p><span>(1) </span>執行系統維護或維修；</p>
<p><span>(2) </span>本服務因不可抗力事件，如意外事件（火災、停電等）、天災、戰爭、暴動、勞資糾紛等，而無法提供；</p>
<p><span>(3) </span>系統故障或系統過載；</p>
<p><span>(4) </span>為確保用戶或第三人安全，或於緊急情況下為維護公眾利益；或</p>
<p><span>(5) </span>除上列第<span>(1)</span>至<span>(4)</span>款所載情事外，於<span>小泉士多</span>合理認為有必要時。</p>
<p><span>&nbsp;</span></p>
<p><span>7. </span>無緊急通報功能</p>
<p>本服務並未搭載能向警察機關、海岸巡防機關、消防機關或其他機關等發出緊急通報的功能。</p>
<p><span>&nbsp;</span></p>
<p><span>8. </span>廣告刊登</p>
<p><span>小泉士多</span>得在本服務刊登<span>小泉士多</span>或第三人的廣告。</p>
<p><span>&nbsp;</span></p>
<p><span>9. </span>第三方服務</p>
<p>本服務內可能包含第三方業者所提供的服務或內容。第三方業者應為其提供的服務及<span>/</span>或內容負責。此外，第三方業者所規定的使用條款及其他條件，可能適用於該等服務或內容。</p>
<p><span>&nbsp;</span></p>
<p><span>10. </span>內容</p>
<p><span>10.1. 小泉士多</span>就<span>小泉士多</span>所提供的本內容授予用戶使用權，此使用權不得轉讓、不得轉授權，且不具有專屬性，並以使用本服務為唯一目的。</p>
<p><span>10.2. </span>如果用戶使用的本內容另有規定使用費、使用期間等使用條件時，用戶即應遵照該等使用條件。即使本服務介面上有顯示「購買」、「販賣」等文字，<span>小泉士多</span>對客戶提供的本內容相關智慧財產權及其他權利亦不因此移轉給用戶，對用戶僅有授予上述使用權。</p>
<p><span>10.3. </span>用戶不得超出本服務所訂定的使用樣態而使用（包括但不限於複製、傳輸、重製和修改等行為）本內容。</p>
<p><span>10.4. </span>請用戶自行備份投稿內容的全部或一部。<span>小泉士多</span>並無義務備份任何投稿內容。</p>
<p><span>10.5. </span>本服務可能具備可使多位用戶編輯內容（投稿、修改、刪除等）的功能。在此情形下，用戶同意其他用戶可編輯該用戶自行投稿的內容。</p>
<p><span>10.6. </span>用戶對投稿內容應有的權利維持不變，<span>小泉士多</span>並未取得相關權利。但若用戶向其他用戶普遍公開投稿內容（亦即，對其他不在好友名單內的用戶亦公開投稿內容），用戶將被視為授權<span>小泉士多</span>得將該投稿內容用於提供服務和促銷目的（包括<span>小泉士多</span>於認有必要且適當的範圍內，加以省略等變更的權利，以及將相關使用權轉授權給與<span>小泉士多</span>有業務合作的第三人的權利）。</p>
<p><span>10.7. </span>用戶不得於<span>小泉士多</span>或第三人依據上述第<span>10.5</span>條及第<span>10.6</span>條使用投稿內容時行使著作人格權。</p>
<p><span>10.8. </span>如<span>小泉士多</span>認為有必要確認有無違反法令或本條款規定等情形時，得於法律及法規允許的範圍內，對投稿內容進行確認。但此不代表<span>小泉士多</span>有義務進行該等確認。</p>
<p><span>10.9. </span>如<span>小泉士多</span>認為用戶投稿內容違反法令或本條款規定或有違反之虞，或有其他業務上需求時，得不事先通知用戶，以刪除投稿內容等方式限制本服務中投稿內容的使用。</p>
<p><span>&nbsp;</span></p>
<p><span>11. </span>代幣</p>
<p><span>11.1. </span>代幣透過在本服務購買、在促銷活動中提供，或以<span>小泉士多</span>指定的其他方式提供給用戶。代幣的購買單位、付款方式、其他代幣提供條件等，由<span>小泉士多</span>訂定並顯示在本服務中或<span>小泉士多</span>網站。</p>
<p><span>11.2. </span>除<span>小泉士多</span>所指定服務或內容外，代幣無法兌換現金、財物或其他經濟利益。兌換服務或內容所需要的代幣數額及其他代幣使用條件，由<span>小泉士多</span>訂定並標註於本服務中或<span>小泉士多</span>網站。</p>
<p><span>11.3. </span>只有在取得代幣的帳號內，方可使用代幣。另，作業系統不同的終端設備所提供的代幣，即使名稱相同但因種類不同，因此無法移轉或合計。</p>
<p><span>11.4. </span>不論任何理由，代幣概不退還。但法令規定有必要者，則不在此限。於此情形下，代幣返還方式將依照法令規定由<span>小泉士多</span>訂定，並顯示在<span>小泉士多</span>網站等處。</p>
<p><span>&nbsp;</span></p>
<p><span>12. </span>訂閱服務之提供</p>
<p><span>12.1. </span>用戶得依據<span>小泉士多</span>訂定的條款及條件付費換取服務，用戶於支付特定金額款項做為對價後，即可於特定期間內使用<span>小泉士多</span>指定的特定內容（以下簡稱「訂閱服務」）。用戶應遵守本條款、訂閱服務的費用和付款方式，以及刊載於本服務或<span>小泉士多</span>網站的其他使用條款及條件。</p>
<p><span>12.2. </span>用戶得隨時採取相關程序取消訂閱服務，但即使用戶於使用期間開始前取消訂閱服務，用戶仍可能無法變更使用期間或取消購買訂閱服務。於此情況下，已支付的費用將無法全額或按比例退款。但法令另有規定者，從其規定。</p>
<p><span>12.3. </span>若用戶未於特定日期及期間前完成取消程序，訂閱服務的使用期間可能依據<span>小泉士多</span>訂定的條款自動展延，即使在訂閱服務的使用期間屆滿後亦然。</p>
<p><span>&nbsp;</span></p>
<p><span>13. </span>禁止事項</p>
<p>用戶於使用本服務時不得從事下列所述行為：</p>
<p><span>13.1. </span>違反法令、法院判決、裁定或命令或具有法令拘束力的行政措施的行為；</p>
<p><span>13.2. </span>恐有危害公共秩序或善良風俗的行為；</p>
<p><span>13.3. </span>侵害著作權、商標權、專利權等智慧財產權、名譽權、隱私權、其他依據法令或與<span>小泉士多</span>及<span>/</span>或第三人合約規定的權利的行為；</p>
<p><span>13.4. </span>投稿或傳送內容有過度暴力的內容、性暗示過度露骨的內容、構成兒童色情或兒童虐待的內容、涉及種族、國籍、信仰、性別、社會地位、家世等有關歧視的內容、引誘或助長自殺、自傷行為或濫用藥物的內容、其他包含反社會情節在內等使人感到不愉快內容的行為；</p>
<p><span>13.5. </span>偽裝成<span>小泉士多</span>及<span>/</span>或第三人的行為或故意散布不實資訊的行為；</p>
<p><span>13.6. </span>傳送相同或類似訊息給大量不特定用戶的行為（經<span>小泉士多</span>同意者除外）、隨機將其他用戶加入為好友或群組的行為、及其他<span>小泉士多</span>判斷為構成垃圾訊息的行為；</p>
<p><span>13.7. </span>藉由<span>小泉士多</span>規定以外的方式，以本內容及本服務的使用權兌換現金、財物或其他經濟利益的行為；</p>
<p><span>13.8. </span>以行銷、宣傳、廣告、招攬或其他營利為目的之行為（經<span>小泉士多</span>同意者除外）、以性行為或猥褻行為為目的之行為、以與未曾謀面的第三人認識或發生性行為為目的之行為、以騷擾或毀謗中傷其他用戶為目的之行為、其他基於與本服務訂定的使用目的不同之目的使用本服務的行為；</p>
<p><span>13.9. </span>對反社會勢力提供利益或其他協助的行為；</p>
<p><span>13.10. </span>勸誘參與宗教活動或宗教團體的行為；</p>
<p><span>13.11. </span>未經授權或不當蒐集、公開或提供他人的個人資料、註冊資料、使用記錄資料等的行為；</p>
<p><span>13.12. </span>干擾本服務的伺服器或網路系統的行為、利用網路機器人（<span>bots</span>）、作弊工具、其他技術性手段不當操作服務的行為、故意利用本服務漏洞的行為、超出必要限度重複同一問題等對<span>小泉士多</span>提出不當洽詢或要求的行為、其他妨礙<span>小泉士多</span>經營本服務或其他用戶使用本服務，並製造干擾的行為；</p>
<p><span>13.13. </span>為達成不合理目的或透過不公平方式，透過逆向工程、反編譯或其他方式對本服務之原始碼進行解碼；</p>
<p><span>13.14. </span>支援或助長符合前述第<span>13.1.</span>項至第<span>13.13</span>項任一行為的行為；以及</p>
<p><span>13.15. </span>前述第<span>13.1.</span>項至第<span>13.14</span>項所述行為外，其他<span>小泉士多</span>合理判斷為不適當的行為。</p>
<p><span>&nbsp;</span></p>
<p><span>14. </span>用戶責任</p>
<p><span>14.1. </span>用戶應自行承擔使用本服務之風險與責任。</p>
<p><span>14.2. </span>若用戶發生或可能發生下列情事，<span>小泉士多</span>得不事先通知用戶，即可中止該用戶使用本服務之全部或一部，停用或刪除帳戶、取消用戶與<span>小泉士多</span>之間關於本服務的合約（包括但不限於依據本條款成立的合約，以下皆同），或採取<span>小泉士多</span>合理認為必要及適當的任何其他措施：</p>
<p><span>(1) </span>用戶違反相關法令、本條款或任何個別條款；</p>
<p><span>(2) </span>用戶為反社會勢力或相關黨派成員；</p>
<p><span>(3) </span>用戶透過散播不實資訊、利用詐欺方式或勢力，或透過其他不法方式破壞<span>小泉士多</span>的信譽；</p>
<p><span>(4) </span>用戶遭聲請被扣押、假扣押、拍賣、進入破產、民事重整或類似程序，或<span>小泉士多</span>合理認為用戶的信用有不確定性；或</p>
<p><span>(5) </span>用戶與<span>小泉士多</span>之間的信任關係已不存在，或因上列第<span>(1)</span>款至第<span>(4)</span>款以外事由，使<span>小泉士多</span>合理認為<span>小泉士多</span>不再適合向用戶提供本服務。</p>
<p><span>14.3. </span>起因於用戶使用本服務（包括但不限於<span>小泉士多</span>收到第三人對於用戶使用本服務所提出的申訴），致<span>小泉士多</span>直接或間接蒙受任何損失<span>/</span>損害（包括但不限於律師費用的負擔）時，用戶應依照<span>小泉士多</span>依循相關法律及法規所提出的要求立即給予補償。</p>
<p><span>&nbsp;</span></p>
<p><span>15. </span>無保證</p>
<p><span>小泉士多</span>不就本服務（包括本內容）作出任何無瑕疵（包括但不限於關於安全性、誤差、錯誤、程式錯誤或侵權）、安全性、可靠性、正確性、完整性、有效性或特定目的之適用性的明示或默示保證。無論如何，<span>小泉士多</span>無須負責將該等缺失刪除後再向用戶提供本服務。</p>
<p><span>&nbsp;</span></p>
<p><span>16. </span>有限責任</p>
<p><span>16.1. </span>用戶若因使用本服務而遭受任何損害，除非該損害係因可歸責於<span>小泉士多</span>的故意或重大過失所致，<span>小泉士多</span>概不負責。但若用戶與<span>小泉士多</span>之間關於本服務的合約屬於台灣消費者保護法定義的消費者合約（下稱「消費者合約」），<span>小泉士多</span>應就任何因<span>小泉士多</span>過失（不含重大過失）而產生的合約或侵權損害提供賠償，惟僅限於：<span>(A) </span>正常產生的損害（亦即，不包括利潤損失及其他因特殊情事而產生的損害）；且<span> (B) </span>賠償金額最高僅限於用戶於發生損害之當月，就付費服務而向<span>小泉士多</span>支付的服務使用費。</p>
<p><span>16.2. </span>若用戶因<span>小泉士多</span>的重大過失而產生損害，<span>小泉士多</span>將負責提供賠償，但僅限於：<span>(A) </span>正常產生的損害（亦即，不包括利潤損失及其他因特殊情事而產生的損害）；且<span> (B) </span>賠償金額最高僅限於用戶於發生損害之當月，就付費服務而向<span>小泉士多</span>支付的服務使用費；但若用戶及<span>小泉士多</span>間的合約屬台灣消費者保護法定義的消費者合約，則不適用前述約定。</p>
<p><span>&nbsp;</span></p>
<p><span>17. </span>本條款及法令間的關係</p>
<p>若本條款違反用戶與<span>小泉士多</span>間就本服務成立的相關合約所適用的相關法令（包括但不限於中華民國消費者保護法），該違法的條款即不應適用於該等用戶合約，但本條款其餘部分不受影響。</p>
<p><span>&nbsp;</span></p>
<p><span>18. </span>聯絡方式</p>
<p><span>18.1. 小泉士多</span>向用戶發送本服務相關通知，將以本服務或<span>小泉士多</span>網站內的適當處公布或其他<span>小泉士多</span>判斷為適當的方式進行。</p>
<p><span>18.2. </span>用戶向<span>小泉士多</span>發送本服務相關通知，請以本服務或<span>小泉士多</span>網站內的適當處所設置的問題反應表傳送或依<span>小泉士多</span>指定方式進行。</p>
<p><span>&nbsp;</span></p>
<p><span>19. </span>準據法、管轄法院</p>
<p>本條款以繁體中文作成（下稱「中文版」），規範用戶與<span>小泉士多</span>之間的關係。若<span>小泉士多</span>有向用戶提供本條款之其他語言譯本，且該譯本與中文版有歧異時，應以中文版為準。本條款的準據法為中華民國法律。用戶與<span>小泉士多</span>間所發生起因於本服務或與本服務有關連的紛爭，以東京地方法院為第一審專屬合意管轄法院。</p>
<p><span>&nbsp;</span></p>
<p>以上</p>
<p><span>&nbsp;</span></p>
<p>最後更新日期：<span>2022</span>年10月<span>31</span>日</p>
<p><span>&nbsp;</span></p>
<p><span>&nbsp;</span></p>
<p><b><span>小泉士多</span>聊天服務之特別條款（僅適用於中華民國臺灣用戶）</b></p>
<p><span>&nbsp;</span></p>
<p>除前述條款外，以下之特別條款（以下簡稱「本特別條款」）專適用於<span>小泉士多</span>（以下簡稱「本公司」）提供予臺灣用戶非商業用途之特定<span>小泉士多</span>好友間一對一即時訊息傳送或<span>小泉士多</span>群組內聊天之<span>小泉士多</span>聊天服務（以下簡稱「本聊天服務」）。本特別條款應視為<span>小泉士多</span>服務條款（以下簡稱「本服務條款」）之一部，如本服務條款之條文與本特別條款之條文有任何牴觸，應以本特別條款之條文為準。所有本特別條款之相關定義應與本服務條款之定義一致，未規定於本特別條款之事宜應以本服務條款之規定為準。</p>
<p><span>&nbsp;</span></p>
<p><span>1. </span>定義</p>
<p>「電子虛擬貨幣」：係指<span>小泉士多 </span>代幣（即<span>小泉士多 Coins</span>）。</p>
<p>「通知」：係指以本公司認為適當之方式對用戶所為之通知、公告或任何通訊，包括但不限於<span>app</span>內之通知、電子郵件、網站公告以及簡訊。</p>
<p>「嚴重濫用」：係指<span>(i)</span>不當攻擊本聊天服務之行為，<span>(ii)</span>以程式或系統自動發布垃圾或騷擾訊息，<span>(iii)</span>創設垃圾帳號或具商業性<span>小泉士多</span>帳號，<span>(iv)</span>經複數人舉報之騷擾行為，<span>(v)</span>以任何異常或未經授權之方式使用本聊天服務，<span>(vi)</span>使用非本公司提供之官方軟體存取本聊天服務，<span>(vii)</span>大量存取與本聊天服務有關之應用程式介面<span>(API)</span>以影響本聊天服務之正常運作，以及<span>(viii)</span>竊取他人<span>小泉士多</span>帳號或創設假帳號以冒充他人。</p>
<p><span>&nbsp;</span></p>
<p><span>2. </span>本聊天服務之提供者</p>
<p>公司名稱：<span>Koizumi Shop Marketing Company Limited</span></p>
<p>地址：3F., No. 9, Ln. 15, Pingan St., Sec. 1, Heping E. Rd.Taipei City, 106003</p>
<p>公司代表人：<span>Yimma Yau</span></p>
<p>網址：<span><a href="https://www.koizumishop.com">https://www.koizumishop.com</a> </span></p>
<p>電話號碼：<span>02-7737-8540</span></p>
<p>聯絡電子郵件地址：<span>support@koizumishop.com</span></p>
<p>※問題反應表填寫之注意事項：</p>
<p>為提供您迅速確實的服務，請確認您輸入於問題反應表之資訊無誤，並提供可確認問題內容的畫面截圖。此外，送出諮詢內容後，您將會收到系統自動寄出的確認信件。我們將於收到您的來信後<span>1</span>～<span>2</span>個工作天內給予您回覆，感謝您的耐心等候。</p>
<p><span>&nbsp;</span></p>
<p><span>3. </span>聊天服務之登入</p>
<p>用戶得透過以下連結確認關於帳號註冊、密碼設定、註冊資料之確認方式等與本聊天服務之使用安全相關之資訊。</p>
<p><span><a href="https://www.facebook.com/koizumishop">https://www.facebook.com/koizumishop</a></span></p>
<p><span>&nbsp;</span></p>
<p><span>4. </span>因可歸責於用戶之<span>小泉士多</span>帳號刪除</p>
<p>當本公司因用戶違反本服務條款而刪除用戶之<span>小泉士多</span>帳號，本公司應通知該用戶以使其改善，如該用戶無視通知而仍未改善或仍繼續違反本服務條款之任一條款時，本公司得不通知該用戶立即刪除其<span>小泉士多</span>帳號。惟，如有下列情形時，本公司得不通知該用戶即刪除其<span>小泉士多</span>帳號：<span>(i)</span>本公司有事實足認用戶涉及詐欺或洗錢等犯罪行為或不法使用，或<span>(ii)</span>用戶構成本特別條款第一條所定義之嚴重濫用時。</p>
<p><span>&nbsp;</span></p>
<p><span>5. </span>久未使用的<span>小泉士多</span>帳號之刪除</p>
<p>就自最後一次連線起已超過一年以上未使用之<span>小泉士多</span>帳號，本公司依據本服務條款，保留刪除該帳號之權利，惟本公司應於刪除之十五日前通知該帳號之用戶，如於此期間用戶有使用該帳號者，則不應予刪除。</p>
<p><span>&nbsp;</span></p>
<p><span>6. </span>帳號遭入侵與終端設備變更</p>
<p><span>(1) </span>當用戶通知本公司其<span>小泉士多</span>帳號被第三人入侵（如帳號遭他人竊取）時，本公司應於確認該入侵行為後，對該帳號進行停權或刪除以保護該被入侵之<span>小泉士多</span>帳號。就<span>小泉士多</span>帳號被竊取之用戶，本公司應提供該用戶關於如何創設新的<span>小泉士多</span>帳號或回復<span>小泉士多</span>帳號（僅限於技術可行之範圍）之資訊，並協助其回復被竊取帳號中之付費商品及尚未使用之電子虛擬貨幣。</p>
<p><span>(2) </span>如用戶因變更其安裝<span>小泉士多</span>帳號之終端設備，而致無法將其<span>小泉士多</span>帳號內之付費商品或未使用之電子虛擬貨幣移轉至新的終端設備時，除非前述該<span>小泉士多</span>帳號之移轉係因用戶不適當操作與<span>小泉士多</span>帳號連動之社交通訊帳號（如<span>小泉士多</span>帳號以外之其他軟體或服務之帳號）所導致者外，本公司應依該用戶之要求，移轉該付費商品與未使用之電子虛擬貨幣至該用戶之新的終端設備之<span>小泉士多</span>帳號中。</p>
<p><span>&nbsp;</span></p>
<p><span>7. 小泉士多</span>帳號遭刪除時之退款</p>
<p>如用戶之<span>小泉士多</span>帳號遭刪除，本公司應於收到用戶之退款要求並完成本公司所要求之個人資料驗證程序後三十日內，選擇以匯款、信用卡、匯票或以掛號郵寄支票之方式，就該<span>小泉士多</span>帳號中剩餘未使用之電子虛擬貨幣退款予用戶。惟，如用戶未提交本公司指定之適當的身分驗證文件，則用戶之退款要求將無效。另，於本公司刪除用戶之<span>小泉士多</span>帳號時，本公司得於退款予用戶前扣除其帳號內剩餘未使用之電子虛擬貨幣總額之百分之三十作為必要成本。為避免疑義，無論刪除<span>小泉士多</span>帳號之理由為何，任何<span>小泉士多</span>帳號一經刪除，用戶皆無權利於刪除後繼續使用本服務。</p>
<p><span>&nbsp;</span></p>
<p><span>8. </span>電子虛擬貨幣之保護與保存措施</p>
<p>本公司應盡合理之努力，依國際支付服務法<span>(Global Payment Service Act)</span>準備並提供必要措施，以保護並保存用戶未使用之電子虛擬貨幣。為遵守國際支付服務法，本公司已與玉山銀行（惟本公司得以通知變更合作銀行）簽訂擔保合約，以保護並保存用戶於使用本聊天服務期間之未使用之虛擬貨幣之相關權益。</p>
<p><span>&nbsp;</span></p>
<p><span>9. </span>因維修暫停聊天服務</p>
<p>如本公司因技術維護之必要（不可抗力事件及其他緊急事故除外），而計畫暫停全部或部份本聊天服務時，本公司應於暫停服務七日前通知用戶。</p>
<p><span>&nbsp;</span></p>
<p><span>10. </span>本特別條款或重要服務內容之變更</p>
<p>本公司於變更本特別條款或變更會影響用戶權益之本聊天服務內容時，應於變更前事先通知用戶，未通知者，則其變更無效。另，若用戶未於本公司為前揭通知後十五日內以書面方式為反對之意思表示，視為接受相關變更。若用戶於本公司為前揭通知後十五日內以書面方式表示不同意變更時，本公司與用戶間關於本聊天服務之契約關係於本公司收受用戶不同意變更之書面表示時即終止，本公司得刪除該用戶之<span>小泉士多</span>帳號，該用戶並應立即停止使用其帳號。</p>
<p><span>&nbsp;</span></p>
<p><span>11. </span>用戶自行刪除<span>小泉士多</span>帳號之確認</p>
<p>於用戶自行刪除其<span>小泉士多</span>帳號時，本公司會於其刪除<span>小泉士多</span>帳號過程中顯示必要通知並提供確認信息給該用戶，以確認用戶之刪除動作並提醒刪除帳戶之後果。</p>
<p><span>&nbsp;</span></p>
<p><span>12. </span>責任</p>
<p><span>(1) </span>本公司將致力於維護本公司之系統符合當時科技水準可合理期待之安全性，以防止不法入侵、取得、竄改、毀損用戶使用本聊天服務之相關紀錄或個人資料，並於系統遭不法入侵或破壞時，採取合理措施以儘速予以回復。</p>
<p><span>(2) </span>本服務條款第<span>16.1</span>條之但書於適用於本聊天服務時，應調整如下：「但本公司與用戶間關於本聊天服務之相關契約（包括但不限於本服務條款），因臺灣消費者保護法等相關法令而被認為無效者，則不適用此免責規定。另，就用戶所受之損害，本公司依臺灣之消費者保護法規定負損害賠償責任。」為避免疑義，本服務條款第<span>16.1</span>條於適用於本聊天服務以外之其他服務時，則無須調整且應予適用。</p>
<p><span>&nbsp;</span></p>
<p><span>13. </span>管轄</p>
<p><span>(1) </span>於適用於本聊天服務時，本服務ta條款第<span>19</span>條最後一行之「專屬」一詞應予刪除，另，本特別條款未排除臺灣之消費者保護法及民事訴訟法上關於管轄之規定。</p>
<p><span>(2) </span>關於本特別條款，應以臺灣法作為準據法。為避免疑義，關於本特別條款外之其他本服務條款，仍應以臺灣法為準據法。</p>
<p><span>&nbsp;</span></p>
<p>本特別條款最後更新日期：<span>2022</span>年<span>10</span>月<span>31</span>日</p><!-- <footer class="mdTerms01Foot">
<p class="mdTerms01Txt">&nbsp;</p>
/mdTerms01Foot</footer> -->
</van-cell>
</div>
    <div style="margin:0 auto; text-align:center;padding-top:10px; padding-bottom:80px;">
      <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      active: 2
    }
  },
  created () {
    this.initPixel()
  },
  mounted () {
  },
  methods: {
    initPixel () {
      window.fbq('init', '519571556714129')
      window.fbq('track', 'PageView')
      window.fbq('track', 'ViewContent')
    },
    onClickLeft () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue